import {Link, useParams} from "react-router-dom";
import {ResidenceService} from "../../../service/residence/ResidenceService";
import {LoadingHelper} from "../../../util/LoadingHelper";
import {useLoadingDispatcher} from "../../../context/LoadingContext";
import {useEffect, useState} from "react";
import {
    convertUniversalDateTimeToPersianDateTime,
    RaikoBaseCardContainer,
    RaikoBaseContainer,
    RaikoMultiSelectTable,
    RaikoSectionContainer,
    showServerErrorMessage, showSuccessMessage, showWarningMessage
} from "@moeindal/base-raiko-panel-components";
import {ResidencesManagerService} from "../../../serverService/residencesManagerService/ResidencesManagerService";
import TableOtherAccessContainer
    from "../../../component/tableCreateHelper/tableOtherAccessContainer/TableOtherAccessContainer";
import {RouteHelper} from "../../../route/RouteHelper";

export default function ResidenceDetailManagerInfo() {

    let page = 0;
    const size = 20;

    const {id: residenceId} = useParams()

    const service = new ResidenceService();
    const managerService = new ResidencesManagerService();
    const loading = new LoadingHelper(useLoadingDispatcher())

    const [selectedManager, setSelectedManager] = useState([])
    const [tableLoading, setTableLoading] = useState(false)
    const [pageCount, setPageCount] = useState(0)
    const [managers, setManagers] = useState([])


    useEffect(() => {
        getManagersListFromServer()
        getDataFromServer()
    }, []);

    function getManagersListFromServer() {
        managerService.getResidencesManagerList(
            page,
            size
        ).then(response => {
            setTableLoading(false)
            setPageCount(response.totalPage)
            setManagers([])
            response.data.map((item, index) => {
                setManagers(prevState => [
                    ...prevState,
                    prepareRowItem(
                        (page * size) + index + 1,
                        item.id,
                        item.metaData.fullName,
                        item.username,
                        item.phoneNumber,
                        item.createdBy,
                        item.createdAt
                    )
                ])
            })
        }).catch(reason => {
            showServerErrorMessage(reason)
        }).finally(() => {

        })
    }

    function prepareRowItem(number, id, name, username, phoneNumber, createdBy, createdAt) {
        return {
            number,
            id,
            name,
            username,
            phoneNumber,
            createdBy,
            createdAt: convertUniversalDateTimeToPersianDateTime(createdAt),
            access: <TableOtherAccessContainer>
                <div
                    className="ic-profile"
                    onClick={e => {
                        e.stopPropagation();
                        e.preventDefault();
                        window.open(RouteHelper.ResidencesManagerInfo.globalUrl.replace(":id", id) + `?title=${encodeURIComponent(name)}`, "_blank");
                    }}
                />
            </TableOtherAccessContainer>
        }
    }

    function getDataFromServer() {
        loading.show()
        service.getResidenceManager(
            residenceId
        ).then((response) => {
            if (response.id)
                setSelectedManager([
                    {
                        id: response.id,
                        name: response.metaData.fullName,
                    }
                ])
        }).catch((reason) => {
            showServerErrorMessage(reason)
        }).finally(() => {
            loading.hide()
        })
    }


    function handleUpdateInfo() {
        if (selectedManager.length > 0) {
            loading.show()
            service.updateResidenceManager(residenceId, selectedManager[0].id)
                .then(() => {
                    showSuccessMessage("بروزرسانی با موفقیت انجام شد.")
                }).catch(reason => {
                showServerErrorMessage(reason)
            }).finally(() => {
                loading.hide()
            })
        } else
            showWarningMessage("لطفا ابتدا یک خادم را انتخاب نمایید.")
    }

    function handleChangePagination(newPage) {
        page = newPage;
        getManagersListFromServer()
    }

    return (
        <RaikoBaseContainer>
            <RaikoBaseCardContainer>
                <RaikoSectionContainer
                    title={"خدام"}
                    subTitle={"مدیریت خادم اقامتگاه"}
                    hasActionButton
                    actionButtonOnclick={handleUpdateInfo}
                >
                    <RaikoMultiSelectTable
                        tableHeader={header}
                        tableData={managers}
                        pageCount={pageCount}
                        selectedItems={selectedManager}
                        setSelectedItems={setSelectedManager}
                        handleChangePagination={handleChangePagination}
                        tableLoadingState={tableLoading}
                        isSingleSelect
                        notSelectedAnyItemAlertTitle={"انتخاب خادم"}
                        notSelectedAnyItemAlertDescription={["لطفا خادم مورد نظر را انتخاب نمایید."]}
                        selectedItemsTitle={"خادم انتخاب شده"}
                        tableHintTitle={"آخرین خدام ثبت نام شده"}
                    />
                </RaikoSectionContainer>
            </RaikoBaseCardContainer>
        </RaikoBaseContainer>
    )
}


const header = [
    {
        id: "number",
        label: "#"
    },
    {
        id: "name",
        label: "نام و نام خانوادگی"
    },
    {
        id: "username",
        label: "نام کاربری"
    },
    {
        id: "phoneNumber",
        label: "شماره همراه"
    },
    {
        id: "createdBy",
        label: "تاریخ ساخت"
    },
    {
        id: "createdAt",
        label: "سازنده"
    },
    {
        id: "access",
        label: "دسترسی"
    },
]